"use client";

import Button from "@/app/components/button";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="min-h-[50vh] flex flex-col items-center justify-center gap-4 px-4">
      <h2 className="h3 uppercase">Something went wrong</h2>
      <Button onClick={() => reset()}>
        Try again
      </Button>
    </div>
  );
}
